/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IRequestContext } from '@msdyn365-commerce/core';

/**
 * Gets correct alt text for image based on configuration of site.
 * @param productName Product name.
 * @param context Current request context.
 * @param imageAltText Alt-text from CMS image.
 */
export function getAltText(
    context: IRequestContext,
    shouldUseCmsAltText: boolean,
    productName?: string,
    imageAltText?: string
): string | undefined {
    if (!context?.app?.config?.OmniChannelMedia) {
        return productName;
    }
    if (shouldUseCmsAltText) {
        return imageAltText;
    }
    return productName;
}
